import { ListViewLocalChildProps } from '@app/core/list-view/ListViewLocal';
import { GroupFromIndex } from '@app/core/types/users';
import { MrtTable } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';

export type AdminGroupsListProps = ListViewLocalChildProps<GroupFromIndex>;

/**
 * Admin user-groups table for ListViewLocal. Filters live in the DataToolbar.
 */
export function AdminGroupsList({
  data,
  isLoading = false,
  isFetching = false,
  showProgress = true,
}: AdminGroupsListProps) {
  const { formatMessage } = useIntl();

  return (
    <Box>
      <MrtTable<GroupFromIndex>
        data={data}
        navigateToOnClick={(id) => `/admin/groups/${id}`}
        enableNavigateAction
        enableColumnFilters={false}
        enableGlobalFilter={false}
        enableToolbarInternalActions={false}
        state={{
          isLoading,
          showProgressBars: showProgress && (isLoading || isFetching),
        }}
        muiTopToolbarProps={{
          sx: {
            height: '4px !important',
            minHeight: '4px !important',
          },
        }}
        columns={[
          {
            header: formatMessage({
              id: 'common.text.name',
              defaultMessage: 'Nombre',
            }),
            size: 100,
            accessorKey: 'name',
          },
          {
            header: formatMessage({
              id: 'admin.groups.listScreen.usersCountHeader',
              defaultMessage: '# Usuarios',
            }),
            size: 50,
            accessorKey: 'usersCount',
            Cell: ({ row: { original } }) => original.usersCount,
          },
        ]}
      />
    </Box>
  );
}
